import { IconArrowRightDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TrackingContainer } from '@mc/visibility'
import Image from 'components/LegacyImage'
import { CategoryHeroMobile } from 'pages/categories/components/CategoryHeroMobile'
import Arrow from '../../assets/red-arrow.svg'
import { trackCatalogPageRowViewed } from '../../events'
import { usePageData } from '../PageDataProvider'
import { HeroDesktop } from './HeroDesktop'
import { HeroTablet } from './HeroTablet'
import { SubcatSelectionTabs } from './SubcatSelectionTabs'
import styles from './Hero.module.scss'

export const Hero = () => {
  const { t } = useTranslation('@mc/next')

  const { subcategories, slug } = usePageData()

  return (
    <>
      <TrackingContainer
        onFirstVisible={() =>
          trackCatalogPageRowViewed({
            rowName: `hero:${t(
              `categories.categoryPage.hero.category.${slug}.headline`,
            )}`,
            categorySlug: slug,
          })
        }
      >
        <HeroDesktop />
        <HeroTablet />
        <CategoryHeroMobile />
      </TrackingContainer>

      <TrackingContainer
        onFirstVisible={() =>
          trackCatalogPageRowViewed({
            rowName: 'sub_category_link_section',
            categorySlug: slug,
          })
        }
      >
        <div className='d-flex flex-column'>
          <div
            className={`d-flex align-items-center justify-content-md-start mc-mb-4 mc-mt-5 ${styles.textOnTop}`}
          >
            <h3 className='mc-mr-2' id='subcategories-list'>
              {t('categories.categoryPage.hero.subcategories.title')}
            </h3>
            <Arrow />
          </div>
          <ul className='row no-gutters' aria-labelledby='subcategories-list'>
            {subcategories.map((subcat, index) => (
              <li key={subcat.id} className='col-12 col-md-6 mc-mb-4 col-lg-4'>
                <SubcatSelectionTabs
                  categorySlug={slug}
                  index={index}
                  subcatName={subcat.name}
                  subcatSlug={subcat.slug}
                >
                  <div className='d-flex align-items-center'>
                    <Image
                      src={subcat.coursePreview.primary1x1}
                      width={40}
                      height={40}
                      className='mc-corners--circle flex-shrink-0'
                      alt=''
                    />
                    <p
                      className='mc-ml-3 mc-text-h6 flex-1'
                      title={subcat.name}
                    >
                      {subcat.name}
                    </p>
                  </div>
                  <div className='flex-shrink-0 d-inline-flex align-items-center justify-content-center mc-corners--circle mc-bg-gray-200 mc-p-2 mc-ml-3'>
                    <IconArrowRightDefault size='sm' />
                  </div>
                </SubcatSelectionTabs>
              </li>
            ))}
          </ul>
        </div>
      </TrackingContainer>
    </>
  )
}
